import { View, Text } from "react-native";
import React from "react";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { styles } from "../styles/styles";
import ProfileIcons from "../../../assets/Icons/FeedIcons/ProfileIcons";

export default function UserProfileDetails({
  currentProfile,
}: {
  currentProfile: any;
}) {
  return (
    <View style={styles.DatingProfileDetails}>
      {currentProfile?.bio && (
        <View style={[styles.ProfileItem]}>
          <Text style={[GlobalStyles.bodyText, { opacity: 0.4 }]}>Bio</Text>
          <Text style={GlobalStyles.heading3}>{currentProfile?.bio}</Text>
        </View>
      )}

      <View style={[styles.ProfileItem]}>
        <Text style={[GlobalStyles.bodyText, { opacity: 0.4 }]}>Vitals</Text>
        <View style={styles.Pills}>
          {currentProfile?.age && (
            <View style={styles.PillItem}>
              <ProfileIcons.BirthdayIcon />
              <Text style={GlobalStyles.bodyText}>{currentProfile?.age}</Text>
            </View>
          )}
          {currentProfile?.gender && (
            <View style={styles.PillItem}>
              <ProfileIcons.GenderIcon />
              <Text style={GlobalStyles.bodyText}>
                {currentProfile?.gender}
              </Text>
            </View>
          )}
          {currentProfile?.userInfo?.height && (
            <View style={styles.PillItem}>
              <ProfileIcons.HeightIcon />
              <Text style={GlobalStyles.bodyText}>
                {currentProfile?.userInfo?.height}
              </Text>
            </View>
          )}
          {currentProfile?.userInfo?.drinker && (
            <View style={styles.PillItem}>
              <ProfileIcons.Drinking />
              <Text style={GlobalStyles.bodyText}>
                {currentProfile?.userInfo?.drinker ? "Yes" : "No"}
              </Text>
            </View>
          )}
          {currentProfile?.userInfo?.smoker && (
            <View style={styles.PillItem}>
              <ProfileIcons.Smoking />
              <Text style={GlobalStyles.bodyText}>
                {currentProfile?.userInfo?.smoker ? "Yes" : "No"}
              </Text>
            </View>
          )}
          {currentProfile?.userInfo?.ethnicity && (
            <View style={styles.PillItem}>
              <ProfileIcons.EthinicityIcon />
              <Text style={GlobalStyles.bodyText}>
                {currentProfile?.userInfo?.ethnicity}
              </Text>
            </View>
          )}
        </View>
      </View>

      <View style={[styles.ProfileItem]}>
        <Text style={[GlobalStyles.bodyText, { opacity: 0.4 }]}>Virtues</Text>
        <View style={styles.Pills}>
          {currentProfile?.userInfo?.company && (
            <View style={styles.PillItem}>
              <ProfileIcons.CurrentPosition />
              <Text style={GlobalStyles.bodyText}>
                {currentProfile?.userInfo?.company}
              </Text>
            </View>
          )}
          {currentProfile?.userInfo?.school && (
            <View style={styles.PillItem}>
              <ProfileIcons.Education />
              <Text style={GlobalStyles.bodyText}>
                {currentProfile?.userInfo?.school}
              </Text>
            </View>
          )}

          {currentProfile?.preferences?.seeking && (
            <View style={styles.PillItem}>
              <ProfileIcons.Seeking />
              <Text style={GlobalStyles.bodyText}>
                {currentProfile?.preferences?.seeking}
              </Text>
            </View>
          )}
          {currentProfile?.userInfo?.relationshipStatus && (
            <View style={styles.PillItem}>
              <ProfileIcons.Status />
              <Text style={GlobalStyles.bodyText}>
                {currentProfile?.userInfo?.relationshipStatus}
              </Text>
            </View>
          )}
        </View>
      </View>
    </View>
  );
}
